import React from "react";
import {
  Csku,
  Tabs,
} from "@commonsku/styles";
import Header from "./Header";
import MainSection from "./MainSection";
import SendVerificationEmail from '../components/tech-support/SendVerificationEmail';
import GeneratePasswordResetLink from '../components/tech-support/GeneratePasswordResetLink';
import EnableQboMapping from '../components/tech-support/EnableQboMapping';
import BackfillQboInvoiceExports from '../components/tech-support/BackfillQboInvoiceExports';
import UnDeletePO from '../components/tech-support/UnDeletePO';
import ProjectTaxMode from '../components/tech-support/ProjectTaxMode';
import ResetShopAggregation from '../components/tech-support/ResetShopAggregation';
import PaymentsPortal from '../components/tech-support/PaymentsPortal';
import { useHasUserFlag } from '../hooks';

const TechSupportApp = () => {
  const hasRestrictedTechSupport = useHasUserFlag('RESTRICTED-TECH-SUPPORT');

  return <>
      <Header />
      <MainSection>
        <div className="main-content">
          <Tabs
            padded={true}
            variant={"secondary"}
            tabs={[
              SendVerificationEmail,
              GeneratePasswordResetLink,
              EnableQboMapping,
              BackfillQboInvoiceExports,
              UnDeletePO,
              ...(hasRestrictedTechSupport ? [ProjectTaxMode, ResetShopAggregation] : []),
              PaymentsPortal,
            ].map(
              (Component): { label: string; content: React.ReactNode } => {
                return {
                  label: Component.label,
                  content: <Component/>,
                };
              }
            )}
          />
        </div>
      </MainSection>
  </>;
};

export default TechSupportApp;
